module.exports = __webpack_public_path__ + "static/media/emojis_24.965f933c.svg";